import { valibotResolver } from '@hookform/resolvers/valibot';
import {
  boolean,
  check,
  hexadecimal,
  length,
  nonEmpty,
  number,
  object,
  pipe,
  string,
} from 'valibot';

export const SENSOR_REPLACE_FIELDS = {
  REASON: 'reason',
  REASON_DESCRIPTION: 'reasonDescription',
  NEW_HEX: 'newHex',
  NEW_PHOTO: 'newPhoto',
  FORCE_REPLACE: 'force_replace',
  CONFIRM_C1D1_REPLACE: 'confirm_c1d1_replace',
};

export const schemaSensorReplace = (reason, confirmC1D1 = false) => {
  let descriptionField = {};
  let confirmC1D1Field = {};
  if (+reason === 3) {
    descriptionField = {
      [SENSOR_REPLACE_FIELDS.REASON_DESCRIPTION]: pipe(string(), nonEmpty('This field is required.')),
    };
  }

  if (confirmC1D1) {
    confirmC1D1Field = {
      [SENSOR_REPLACE_FIELDS.CONFIRM_C1D1_REPLACE]: pipe(
        boolean(),
        check((value) => value === true, 'This field is required'),
      ),
    };
  }

  return valibotResolver(
    object({
      [SENSOR_REPLACE_FIELDS.REASON]: pipe(
        object({ id: number('This field is required.') }),
        nonEmpty('This field is required.'),
      ),
      ...descriptionField,
      [SENSOR_REPLACE_FIELDS.NEW_HEX]: pipe(
        string(),
        length(6, 'Your Hex code must be 6 characters.'),
        hexadecimal('Please enter correct Hex code.'),
        nonEmpty('This field is required.'),
      ),
      [SENSOR_REPLACE_FIELDS.NEW_PHOTO]: pipe(string(), nonEmpty('This field is required.')),
      [SENSOR_REPLACE_FIELDS.FORCE_REPLACE]: number(),
      ...confirmC1D1Field,
    }),
  );
};

export const sensorReplaceDefaultValue = {
  [SENSOR_REPLACE_FIELDS.REASON]: { id: null },
  [SENSOR_REPLACE_FIELDS.REASON_DESCRIPTION]: '',
  [SENSOR_REPLACE_FIELDS.NEW_HEX]: '',
  [SENSOR_REPLACE_FIELDS.NEW_PHOTO]: '',
  [SENSOR_REPLACE_FIELDS.FORCE_REPLACE]: 0,
  [SENSOR_REPLACE_FIELDS.CONFIRM_C1D1_REPLACE]: false,
};
